/**
 * T_Component FI_ID for the "form" component
 */
export const EPIC_LINK_APP_ID = 1617;

/**
 * T_Component FI_ID for the "form" component
 */
export const EPIC_LINK_COMPONENT_ID = 5648;

/**
 * Epic Link form field key names
 */
export const LINK_FIELD_KEYS = {
	PHONE_NUMBER: 'phoneNumber',
	EMAIL_ADDRESS: 'emailAddress',
	JOB_CATEGORY: 'jobCategory',
	SURGICAL_SCHEDULING: 'surgicalScheduling',
	NPI: 'npi',
	NPI_VERIFICATION: 'npiVerification',
	LICENSE_ID: 'licenseId',
	LICENSE_STATE: 'licenseState',
	LOCATIONS: 'locations',
	COMMENTS: 'comments',
};
